// extracted by mini-css-extract-plugin
export var messageSideLeft = "_le-1";
export var messageSideRight = "_le-2";
export var orderLookupBubbleContainer = "_le-0";
export var submitButton = "_le-3";